import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#EAE5D9] bg-[#F5F2EB] mt-24">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-display text-2xl text-[#2D2A26]">Divine Alignment</div>
          <p className="mt-3 text-sm text-[#5C5852] leading-relaxed max-w-xs">
            A faith-based course for anyone learning to align their voice with their calling — online and off.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#8A857D] mb-3">Course</div>
          <ul className="space-y-2 text-sm text-[#2D2A26]">
            <li><Link to="/curriculum">Curriculum</Link></li>
            <li><Link to="/assessment">Assessment</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-[#8A857D] mb-3">Connect</div>
          <ul className="space-y-2 text-sm text-[#2D2A26]">
            <li><Link to="/speaker">Book the Speaker</Link></li>
            <li><Link to="/login">Sign in</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#EAE5D9]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 text-xs text-[#8A857D] flex justify-between items-center">
          <span>© {new Date().getFullYear()} Divine Alignment</span>
          <span className="italic">"He will make your paths straight." — Proverbs 3:6</span>
        </div>
      </div>
    </footer>
  );
}
